import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

type RewriteInstructionRefusedDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  translationKeyPrefix: 'riskAssessmentPage' | 'manualGenerationPage'
}

export function RewriteInstructionRefusedDialog({
  open,
  onOpenChange,
  translationKeyPrefix,
}: RewriteInstructionRefusedDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`${translationKeyPrefix}.rewriteInstructionRefusedDialog.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(
              `${translationKeyPrefix}.rewriteInstructionRefusedDialog.description`
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            {t(`${translationKeyPrefix}.rewriteInstructionRefusedDialog.close`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
